module.exports = __webpack_public_path__ + "img/img23.5406a790.png";